export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';
export const SET_ACCESS = 'SET_ACCESS';
export const SET_OK = 'SET_OK';
export const RESET = 'RESET';
export const SET_USER_DATA = 'SET_USER_DATA';